var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"large":"","outlined":"","color":"#1D3557","dark":""},on:{"click":function($event){return _vm.$emit('backClicked')}}},[_c('icon',{staticClass:"mr-2",attrs:{"icon":"arrow-left"}}),_vm._v("Back ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }